import axios from "axios";
import { OrganizationURL } from "../../../config/UrlEndPoint";

export const URL = `${OrganizationURL}organization/`;

// Get OrganizationReport All
export function getOrganizationReportAll() {
  return axios.get(URL);
}

// //Get By ID
export function getOrganizationReportById(organizationReportId) {
  return axios.get(`${URL}/get_report/${organizationReportId}`);
}

// POST => POST: Create the organizationReport on the server
export function createOrganizationReport(payload) {
  return axios.post(`${URL}create_report`, payload);
}

// items => filtered/sorted result for table data
export function findOrganizationReport(queryParams) {
  return axios.post(`${URL}find_report`, queryParams);
}

export function getOrganizationReportFiltered(filter) {
  return axios.post(`${URL}/filtered`, filter);
}

// UPDATE => PUT: update the organizationReport on the server
export function updateOrganizationReport(payload) {
  return axios.put(`${URL}update_report`, payload);
}

export function deleteOrganizationReport(uuid) {
  return axios.delete(`${URL}delete_report/${uuid}`);
}

export const findDonationConsolidation = queryParams => {
  return axios.post(`${URL}find_donation_consolidation`, queryParams);
};
